import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import useAdvertisements, { AdvertisementEvent } from "./useAdvertisements";
import Ad from "../Ad";

type Props = {
  userId: string;
  widgetId: string;
};

const AdvertisementWidgetEmbed = ({ userId, widgetId }: Props) => {
  const {
    advertisement,
    identifier,
    visible,
    willDisappear,
    showAdvertisement,
    playAdvertisement,
  } = useAdvertisements();

  useTopic(`widget:${widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "advertisement:show":
        showAdvertisement(message.payload as AdvertisementEvent);
        break;
    }
  });

  useTopic(`user:widgets:advertisement:${userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  if (!advertisement) {
    return null;
  }

  return (
    <Ad
      key={identifier}
      visible={visible}
      willDisappear={willDisappear}
      advertisement={advertisement}
      onReady={() => playAdvertisement()}
    />
  );
};

export default AdvertisementWidgetEmbed;
